<template>
    <dx-data-grid
        ref="dataGridRef"
        :allow-column-reordering="true"
        :column-chooser="{ enabled: true, mode: 'select' }"
        :column-min-width="50"
        :columns="columns"
        :data-source="dataSource"
        :filter-row="{ visible: true }"
        :header-filter="{ visible: true }"
        :height="50"
        :hover-state-enabled="true"
        :remote-operations="{ filtering: true, paging: true, sorting: true, summary: true }"
        :repaint-changes-only="true"
        :row-alternation-enabled="true"
        :show-borders="true"
        :show-column-lines="true"
        :width="'100%'"
        :word-wrap-enabled="true"
        style="flex-grow: 1"
        value-expr="id"
        @toolbar-preparing="onToolbarPreparing($event)"
        @on-cell-prepared="onCellPrepared($event)"
        @content-ready="onContentReady($event)"
    >
        <dx-paging :enabled="true" :page-size="40" />
        <dx-load-panel :enabled="true" />
        <dx-scrolling mode="virtual" />
        <dx-sorting mode="single" />
        <dx-export :allow-export-selected-data="true" :enabled="true" :formats="['pdf', 'excel']" />
        <dx-editing
            :allow-updating="true"
            :allow-deleting="true"
            :refresh-mode="'full'"
            mode="batch"
        />
    </dx-data-grid>
</template>

<script>
export default {
    name: 'mped-amortization-group-view',
};
</script>

<script setup>

import {
    DxDataGrid,
    DxEditing,
    DxExport,
    DxLoadPanel,
    DxPaging,
    DxScrolling,
    DxSorting,
} from 'devextreme-vue/data-grid';

import { checkHasEditData, getAiToolbar } from '@/components/utils/ai-toolbar-generator';
import { ref } from 'vue';
import { addNewRowData, getAiDataSource } from '@/components/utils/ai-data-source-generator';
import { getAmortizationGroups, setAmortizationGroups } from '@/views/mped/services/mped-amortization-api-service';
import { amortizationGroupsColumns } from '@/views/mped/services/mped-amortization-service';

const dataGridRef = ref();
let toolbarButtons = {};

const columns = amortizationGroupsColumns();

const dataSource = getAiDataSource(
    {
        dataFn: getAmortizationGroups,
        key: 'id',
        remoteOperation: true,
        insertFn: (values) => {
            return setAmortizationGroups({ insertDataArgs: [values] });
        },
        updateFn: (id, values) => {
            return setAmortizationGroups({ updateDataArgs: [{ id, ...values }] });
        },
        removeFn: (id) => {
            return setAmortizationGroups({ deleteDataArgs: [{ id }] });
        },
    },
);

const onToolbarPreparing = (e) => {
    toolbarButtons = getAiToolbar(e, {
        refresh: {
            event: reloadData,
        },
        add: {
            event: addData,
        },
        save: {
            event: (e) => {
                dataGridRef.value.instance.saveEditData();
            },
        },
    });
};

const reloadData = () => {
    dataSource.reload();
};

const addData = (e) => {
    addNewRowData({
        dxInstance: dataGridRef.value.instance,
        sourceData: {
            id: e.id,
            ...e,
        },
        fields: ['name', 'code', 'spi', 'min_month', 'max_month', 'is_match'],
    });
    dataSource.reload();
};

const onContentReady = (e) => {
    checkHasEditData(dataGridRef.value.instance, toolbarButtons);
};

const onCellPrepared = (e) => {
    if (e.rowType !== 'data' || e.columnIndex != 0) {
        return;
    }
};

</script>
